

/* product input */
$('.qty_button').click(function () {
    let val = $(this).val();
    let input = $(this).siblings('.qty_input');
    input.each(function () {
        if (val == 1) {
            $(this).val(parseInt($(this).val()) + 1);
        } else if ($(this).val() - 1 > 0) {
            $(this).val(parseInt($(this).val()) - 1);
        }
    });
});



$('.toggle_wish_list').click(function () {
    let product_id = $(this).data('product_id');
    let item = $(this);
    axios.post('wishlist',{
        product_id:product_id,
    }).then(res => {
        if (res.data.status == 1) {
            item.children().addClass('ri-heart-fill').removeClass('ri-heart-line');
        } else {
            item.children().removeClass('ri-heart-fill').addClass('ri-heart-line');
        }
    })
});
